import React from 'react'

export default (props: any) => (
  <svg {...props} width="66" height="51" viewBox="0 0 66 51" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M66 18.025H0V32.869H66V18.025Z" fill="white" />
    <path d="M66 0H0V18.025H66V0Z" fill="#A2001D" />
    <path d="M66 32.869H0V51H66V32.869Z" fill="#A2001D" />
    <path d="M65.5 0.5H0.5V50.5H65.5V0.5Z" stroke="#9F9D9D" />
  </svg>
)
